import { render, staticRenderFns } from "./deposit_fromAdmin.vue?vue&type=template&id=4f96c896&scoped=true&"
import script from "./deposit_fromAdmin.vue?vue&type=script&lang=js&"
export * from "./deposit_fromAdmin.vue?vue&type=script&lang=js&"
import style0 from "./deposit_fromAdmin.vue?vue&type=style&index=0&id=4f96c896&prod&scoped=true&lang=css&"
import style1 from "./deposit_fromAdmin.vue?vue&type=style&index=1&id=4f96c896&prod&lang=scss&scoped=true&"
import style2 from "./deposit_fromAdmin.vue?vue&type=style&index=2&id=4f96c896&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f96c896",
  null
  
)

export default component.exports